import React from "react";
import { useMatch, useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Card,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import Countries from "src/data/countries.json";
import { Icon } from "@iconify/react";

import { Divider } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { Form, FormikProvider, useFormik } from "formik";

import {
  acceptableCurrencyList,
  getCompanyDefaultValues,
} from "./company.constants";
import { companyFormValidationSchema } from "src/util/validationSchemas";
import {
  availablePaymentGatewayListUrl,
  companyUrl,
  getCompanyUrlId,
} from "src/react-query/endPoints";
import {
  useGetDetail,
  useGetPaymentGatewayDetails,
  useGetPaymentGatewayList,
  useList,
  useMutate,
} from "src/hooks/useFetch.hook";
import { useCallback, useEffect, useRef, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { Loader } from "../Loader";
import { is } from "src/util/is";
import Address from "src/common/components/Address";
import { alertSlice } from "src/store/alert/alert.slice";
import { useDispatch } from "react-redux";
import { useDomainConfig } from "src/hooks/useDomainConfig";
import { useMutation } from "@tanstack/react-query";
import { iconUpload } from "src/components/ServiceRequest/serviceRequest.hook";
import { UploadImage } from "./uploadImage";

export const CompanyForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const domainConfig = useDomainConfig();
  const { companyId } = useParams();
  const { mutate, isLoading } = useMutate("companyList");
  const {
    mutate: availablePaymentGatewayList,
    isLoading: isFetchingAvailablePaymentGatewayList,
  } = useGetPaymentGatewayList();
  const isCreateCompany = useMatch("/company/new");
  const { data: company, isFetching } = useGetDetail("company", {
    id: companyId,
  });
  const iconList = [
    {
      iconTitle: "Grey Icon",
      iconKey: "greyIcon",
    },
    {
      iconTitle: "Green  Icon",
      iconKey: "greenIcon",
    },
    {
      iconTitle: "Red Icon",
      iconKey: "redIcon",
    },
    {
      iconTitle: "Icon",
      iconKey: "icon",
    },
  ];
  // const [savedPaymentGatewayId,setSavedPaymentGatewayId] = useState(null);
  // const { data: paymentGatewayDetails, isFetching:isFetchingPaymentGatwayDetails } = useGetPaymentGatewayDetails(isCreateCompany,savedPaymentGatewayId)
  const [gatewayList, setGatewayList] = useState([]);
  const [showCustomDomainInput, setShowCustomDomainInput] = useState(false);
  // const domainProviderMap = {
  //   amiktechnologies: { name: "AMIK Technologies" },
  //   moveonev: { name: "MoveonEV" },
  //   avvtech: { name: "AvvTech" },
  // };
  const domainProviderMap = {
    amiktechnologies: {
      name: "AMIK Technologies",
      icons: {
        greyIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/grey/amik.png",
        greenIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/green/amik.png",
        redIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/red/amik.png",
        icon: "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/amik.png",
      },
      countryCode: "+91",
    },
    moveonev: {
      name: "MoveonEV",
      icons: {
        greyIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/grey/moveonev.png",
        greenIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/green/moveonev.png",
        redIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/red/moveonev.png",
        icon: "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/moveonev.png",
      },
      countryCode: "+91",
    },
    avvtech: {
      name: "AvvTech",
      icons: {
        greyIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/grey/amik.png",
        greenIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/green/amik.png",
        redIcon:
          "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/red/amik.png",
        icon: "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/amik.png",
      },
      countryCode: "+1",
    },
  };
  const onSubmit = async (companyData, { setSubmitting }) => {
    try {
      const {
        street,
        houseNumber,
        zipCode,
        city,
        state,
        country,
        locationLatitude,
        locationLongitude,
        addressId,
        paymentGatewayDetailsId,
        taxPercent,
        transactionPercent,
        companyProtocolType,
        token,
        endpoint,
        partyId,
      } = companyData;
      const {
        actions: { setAlert },
      } = alertSlice;

      //IMPORTANT VALIDATIONS

      // const zeroValue=(val)=>parseFloat(val)===0
      // if(zeroValue(transactionPercent) || zeroValue(taxPercent)){
      //   let errorsUpd = {...errors,transactionPercent:zeroValue(transactionPercent)?"Specify a value greater than zero":"",taxPercent:zeroValue(taxPercent)?"Specify a value greater than zero":""}
      //   setErrors(errorsUpd);
      //   dispatch(
      //     setAlert({
      //       open: true,
      //       message: `Specify a value greater than zero for the percentages`,
      //       severity: "error",
      //     })
      //   );
      //   setSubmitting(false);
      //   return
      // }

      // Removed validation for paymentGatewayDetailsId === 0 to allow "None" option

      if (companyProtocolType === "ocpi" && (!token || !endpoint || !partyId)) {
        let errorsUpd = {
          ...errors,
          token: !token ? "Token is required" : "",
          endpoint: !endpoint ? "Endpoint is required" : "",
          partyId: !partyId ? "Party ID is required" : "",
        };
        setErrors(errorsUpd);
        dispatch(
          setAlert({
            open: true,
            message: "Token, Endpoint, and Party ID are required for OCPI",
            severity: "error",
          })
        );
        setSubmitting(false);
        return;
      }

      // const provider = await UploadProviderImagesToAWS();
      // provider.name = companyData.name;
      // companyData.provider = provider;
      // setFieldValue("provider", provider);
      const updatedProvider = await UploadProviderImagesToAWS();
      companyData.provider = {
        ...updatedProvider,
        name: values.provider.name,
      };

      companyData.address = {
        street,
        houseNumber,
        zipCode,
        city,
        state,
        country,
        lat: locationLatitude,
        lng: locationLongitude,
      };

      const mutateObject = {
        url: companyUrl,
        method: "POST",
      };

      if (!isCreateCompany && !is.nullOrUndefined(companyId)) {
        mutateObject.method = "PUT";
        mutateObject.url = getCompanyUrlId(companyId);
        companyData.address.addressId = addressId;
        delete companyData.addressId;
      }
      // companyData.domain = domainConfig.domain;

      if (domainProviderMap[companyData.domain]) {
        companyData.provider = {
          ...companyData.provider,
          ...domainProviderMap[companyData.domain].icons,
          countryCode: domainProviderMap[companyData.domain].countryCode,
        };
      }

      // Ensure paymentGatewayDetailsId is null if empty string or undefined
      if (
        is.empty(companyData.paymentGatewayDetailsId) ||
        companyData.paymentGatewayDetailsId === "" ||
        companyData.paymentGatewayDetailsId === 0
      ) {
        companyData.paymentGatewayDetailsId = null;
      }

      mutate(
        {
          url: mutateObject.url,
          method: mutateObject.method,
          body: { company: companyData },
        },
        {
          onSuccess,
          onError: (error) => {
            console.error("Mutation error:", error);
            dispatch(
              setAlert({
                open: true,
                message: "Failed to save company",
                severity: "error",
              })
            );
            setSubmitting(false);
          },
        }
      );
    } catch (error) {
      console.error("CompanyForm: Error submitting company data:", {
        error: error.message,
        stack: error.stack,
        companyData: {
          companyName: companyData.companyName,
          companyId: companyData.companyId
        }
      });
      setSubmitting(false);
    }
  };

  const onSuccess = () => navigate("/company");

  const formik = useFormik({
    initialValues: getCompanyDefaultValues(),
    validationSchema: companyFormValidationSchema,
    onSubmit,
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    isSubmitting,
    getFieldProps,
    resetForm,
    setFieldValue,
    setErrors,
  } = formik;

  const UploadProviderImagesToAWS = async () => {
    return new Promise(async (res) => {
      const provider = values["provider"];

      for await (let data of iconList) {
        const icon = provider[data?.iconKey];
        if (icon && !icon.startsWith("http")) {
          const response = await iconUpload({ image: provider[data?.iconKey] });
          provider[data.iconKey] = response.data.data;
        }
      }
      res(provider);
    });
  };

  useEffect(() => {
    if (company) {
      let {
        address,
        paymentGatewayDetailsId,
        paymentCurrency,
        payoutAccounts,
        provider,
        companyProtocolType,
        token,
        endpoint,
        partyId,
        ...rest
      } = company;

      const { zipcode, lat, lng } = address;
      let finalPayoutAccountsArr = [
        {
          business_name: "",
          business_type: "",
          beneficiary_name: "",
          email: "",
          phone: "",
          account_no: "",
          ifsc_code: "",
          settlement_percentage: "",
          disabled: false,
        },
      ];
      if (!is.empty(payoutAccounts)) {
        finalPayoutAccountsArr = [...payoutAccounts];
      }
      const companyValues = {
        ...rest,
        ...address,
        zipCode: zipcode,
        locationLatitude: lat,
        locationLongitude: lng,
        payoutAccounts: finalPayoutAccountsArr,
        paymentGatewayDetailsId,
        paymentCurrency,
        provider,
        companyProtocolType,
        token: token || null,
        endpoint: endpoint || null,
        partyId: partyId || null,
      };
      resetForm({ values: companyValues });
    }
  }, [company, resetForm]);

  useEffect(() => {
    const mutateObject = {
      url: availablePaymentGatewayListUrl,
      method: "GET",
    };
    availablePaymentGatewayList(mutateObject, {
      onSuccess: (data) => {
        const { data: list } = data;
        if (!is.empty(list)) {
          setGatewayList(list);
        }
      },
    });
  }, []);

  if (isFetching) {
    return <Loader />;
  }

  if (!isCreateCompany && is.empty(company)) {
    navigate("/company");
    return null;
  }
  return (
    <Card sx={{ p: 2 }}>
      <FormikProvider value={formik}>
        <Form
          autoComplete="off"
          id="company"
          noValidate
          onSubmit={handleSubmit}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small">
                <TextField
                  required
                  id="outlined-basic"
                  label="Company Name"
                  size="small"
                  {...getFieldProps("name")}
                  error={Boolean(touched.name && errors.name)}
                  helperText={touched.name && errors.name}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                  Subscription Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Subscription Type"
                  {...getFieldProps("subscriptionId")}
                >
                  <MenuItem value={1}>Basic</MenuItem>
                  <MenuItem value={2}>Chargemiles</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {/* // Domain select field */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="domain-label">Domain</InputLabel>
                {/* <Select
                  labelId="domain-label"
                  id="domain-select"
                  label="Domain"
                  value={
                    domainProviderMap[values.domain] ? values.domain : "custom"
                  }
                  onChange={(e) => {
                    const selectedDomain = e.target.value;
                    if (selectedDomain === "custom") {
                      setShowCustomDomainInput(true);
                      setFieldValue("domain", "");
                      setFieldValue("provider", {
                        ...values.provider,
                        name: "",
                      });
                    } else {
                      setShowCustomDomainInput(false);
                      setFieldValue("domain", selectedDomain);
                      setFieldValue("provider", {
                        ...values.provider,
                        name: domainProviderMap[selectedDomain].name,
                      });
                    }
                  }}
                  error={Boolean(touched.domain && errors.domain)}
                >
                  {Object.keys(domainProviderMap).map((domain) => (
                    <MenuItem key={domain} value={domain}>
                      {domain}
                    </MenuItem>
                  ))}
                  <MenuItem value="custom">Other (enter custom)</MenuItem>
                </Select> */}
                <Select
                  labelId="domain-label"
                  id="domain-select"
                  label="Domain"
                  value={
                    domainProviderMap[values.domain] ? values.domain : "custom"
                  }
                  onChange={(e) => {
                    const selectedDomain = e.target.value;
                    if (selectedDomain === "custom") {
                      setShowCustomDomainInput(true);
                      setFieldValue("domain", "");
                      setFieldValue("provider", {
                        name: "",
                        greyIcon: "",
                        greenIcon: "",
                        redIcon: "",
                        icon: "",
                        countryCode: "+91", // Default country code for custom domains
                      });
                    } else {
                      setShowCustomDomainInput(false);
                      setFieldValue("domain", selectedDomain);
                      setFieldValue("provider", {
                        name: domainProviderMap[selectedDomain].name,
                        ...domainProviderMap[selectedDomain].icons,
                        countryCode:
                          domainProviderMap[selectedDomain].countryCode,
                      });
                    }
                  }}
                  error={Boolean(touched.domain && errors.domain)}
                >
                  {Object.keys(domainProviderMap).map((domain) => (
                    <MenuItem key={domain} value={domain}>
                      {domain}
                    </MenuItem>
                  ))}
                  <MenuItem value="custom">Other (enter custom)</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {/* Custom domain input */}
            {(showCustomDomainInput ||
              (values.domain && !domainProviderMap[values.domain])) && (
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <TextField
                    label="Domain"
                    size="small"
                    value={values.domain}
                    onChange={(e) => {
                      setFieldValue("domain", e.target.value);
                      setShowCustomDomainInput(e.target.value !== "");
                    }}
                    error={Boolean(touched.domain && errors.domain)}
                    helperText={touched.domain && errors.domain}
                  />
                </FormControl>
              </Grid>
            )}
            {/* Provider name field */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small">
                <TextField
                  label="Provider Name"
                  size="small"
                  value={values.provider?.name || ""}
                  onChange={(e) => {
                    setFieldValue("provider", {
                      ...values.provider,
                      name: e.target.value,
                    });
                  }}
                  error={Boolean(
                    touched.provider?.name && errors.provider?.name
                  )}
                  helperText={touched.provider?.name && errors.provider?.name}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="payment-type">Payment Type</InputLabel>
                <Select
                  labelId="payment-type"
                  id="demo-simple-select"
                  label="Payment Type"
                  {...getFieldProps("paymentConfirmationNo")}
                >
                  <MenuItem value="card">Card</MenuItem>
                  <MenuItem value="upi">UPI</MenuItem>
                  <MenuItem value="cash">Cash</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl
                fullWidth
                size="small"
                error={Boolean(
                  touched.paymentCurrency && errors.paymentCurrency
                )}
              >
                <InputLabel id="demo-simple-select-label">
                  Payment Currency Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Payment Currency Typee"
                  {...getFieldProps("paymentCurrency")}
                  value={values["paymentCurrency"]}
                >
                  {acceptableCurrencyList.map(({ value, title }, index) => (
                    <MenuItem
                      value={value}
                      key={`${value}-${index}-currency-${title}`}
                    >
                      {title}
                    </MenuItem>
                  ))}
                </Select>
                {touched.paymentCurrency && (
                  <FormHelperText>{errors.paymentCurrency}</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                  Payment Gateway
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Payment Gateway"
                  value={values.paymentGatewayDetailsId ?? ""}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (value === "") {
                      // "None" option selected - set to null
                      setFieldValue("paymentGatewayDetailsId", null);
                      setFieldValue("paymentGatewayId", "1");
                    } else {
                      const selectedGateway = gatewayList.find(
                        (gateway) => gateway.id === value
                      );
                      if (selectedGateway) {
                        setFieldValue(
                          "paymentGatewayDetailsId",
                          selectedGateway.id
                        );
                        setFieldValue(
                          "paymentGatewayId",
                          selectedGateway.payment_gateway_id
                        );
                      }
                    }
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {gatewayList.map((value, index) => (
                    <MenuItem
                      value={value?.id}
                      key={`${value?.id}-${index}-gateway-${value?.name}`}
                    >
                      {value?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small">
                <TextField
                  required
                  id="outlined-basic"
                  label="Tax Percentage"
                  size="small"
                  {...getFieldProps("taxPercent")}
                  error={Boolean(touched.taxPercent && errors.taxPercent)}
                  helperText={touched.taxPercent && errors.taxPercent}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small">
                <TextField
                  required
                  id="outlined-basic"
                  label="Transaction Percentage"
                  size="small"
                  {...getFieldProps("transactionPercent")}
                  error={Boolean(
                    touched.transactionPercent && errors.transactionPercent
                  )}
                  helperText={
                    touched.transactionPercent && errors.transactionPercent
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="company-type-label">Company Type</InputLabel>
                <Select
                  labelId="company-type-label"
                  id="company-type"
                  label="Company Type"
                  {...getFieldProps("companyProtocolType")}
                >
                  <MenuItem value="ocpp">OCPP</MenuItem>
                  <MenuItem value="ocpi">OCPI</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {values.companyProtocolType === "ocpi" && (
              <>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth size="small">
                    <TextField
                      required
                      id="token"
                      label="Token"
                      size="small"
                      {...getFieldProps("token")}
                      error={Boolean(touched.token && errors.token)}
                      helperText={touched.token && errors.token}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth size="small">
                    <TextField
                      required
                      id="endpoint"
                      label="Endpoint"
                      size="small"
                      {...getFieldProps("endpoint")}
                      error={Boolean(touched.endpoint && errors.endpoint)}
                      helperText={touched.endpoint && errors.endpoint}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth size="small">
                    <TextField
                      required
                      id="partyId"
                      label="Party ID"
                      size="small"
                      {...getFieldProps("partyId")}
                      error={Boolean(touched.partyId && errors.partyId)}
                      helperText={touched.partyId && errors.partyId}
                    />
                  </FormControl>
                </Grid>
              </>
            )}
          </Grid>
          <Address
            getFieldProps={getFieldProps}
            setFieldValue={setFieldValue}
            formValues={values}
            hide={true}
            displayedFor="company"
          />
          <Grid container spacing={2}>
            <Grid item xs={12} lg={12}>
              <Typography variant="subtitle1" className="mb-2">
                Company Info
              </Typography>
              <Divider />
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl fullWidth size="small">
                <TextField
                  size="small"
                  id="outlined-basic"
                  label="Root User"
                  {...getFieldProps("rootUser")}
                  disabled={!isCreateCompany}
                  error={Boolean(touched.rootUser && errors.rootUser)}
                  helperText={touched.rootUser && errors.rootUser}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl fullWidth size="small">
                <TextField
                  id="outlined-basic"
                  label="Email Address"
                  size="small"
                  disabled={!isCreateCompany}
                  {...getFieldProps("emailId")}
                  error={Boolean(touched.emailId && errors.emailId)}
                  helperText={touched.emailId && errors.emailId}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} lg={12}>
              <Typography variant="subtitle1" className="mb-2">
                Add Icons
              </Typography>
              <Divider sx={{ marginBottom: "8px" }} />
            </Grid>
            {/* {iconList.map((data) => (
              <Grid item xs={12} lg={3} key={data.iconKey}>
                <UploadImage
                  getFieldProps={getFieldProps}
                  setFieldValue={setFieldValue}
                  formValues={values}
                  iconKey={data.iconKey}
                  iconTitle={data.iconTitle}
                  iconUrl={values.provider?.[data.iconKey] || ""}
                />
              </Grid>
            ))} */}
            {iconList.map((data) => (
              <Grid item xs={12} lg={3} key={data.iconKey}>
                <UploadImage
                  getFieldProps={getFieldProps}
                  setFieldValue={setFieldValue}
                  formValues={values}
                  iconKey={data.iconKey}
                  iconTitle={data.iconTitle}
                  iconUrl={values.provider?.[data.iconKey] || ""}
                  disabled={
                    domainProviderMap[values.domain] && !showCustomDomainInput
                  }
                />
                {domainProviderMap[values.domain] && !showCustomDomainInput && (
                  <Typography variant="caption" color="textSecondary">
                    Icon is set by domain selection
                  </Typography>
                )}
              </Grid>
            ))}
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={12}>
              <Typography variant="subtitle1" className="mb-2">
                Comments
              </Typography>
              <Divider />
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl fullWidth size="small">
                <TextField
                  sx={{ m: 1, width: 500 }}
                  id="outlined-multiline-static"
                  multiline
                  rows={4}
                  {...getFieldProps("comments")}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid container mt={3}>
            <Grid item xs={6} lg={6}>
              <Stack direction="row" spacing={2}>
                <Button
                  size="medium"
                  type="button"
                  variant="outlined"
                  component={RouterLink}
                  to="/company"
                  startIcon={<Icon icon="eva:close-outline" />}
                  sx={{
                    px: 3,
                    py: 1,
                    textTransform: 'none',
                    fontWeight: 500,
                  }}
                >
                  Cancel
                </Button>
                <LoadingButton
                  size="medium"
                  type="submit"
                  variant="contained"
                  loading={isSubmitting || isLoading}
                  startIcon={<Icon icon="eva:save-outline" />}
                  sx={{
                    px: 3,
                    py: 1,
                    textTransform: 'none',
                    fontWeight: 500,
                  }}
                >
                  {isSubmitting || isLoading ? 'Saving...' : 'Save Changes'}
                </LoadingButton>
              </Stack>
            </Grid>
          </Grid>
        </Form>
      </FormikProvider>
    </Card>
  );
};
